import styled, { css } from 'styled-components';

import { mediaQuery, Button } from '@catalyze/ui';

export const Container = styled.section`
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 70vh;
    margin: 2rem -1rem;
    ${mediaQuery(
        2,
        css`
            margin: 0 -2.375rem 0 -4.125rem;
        `
    )}
`;

export const StyledButton = styled(Button)`
    width: 10rem;
    margin-top: 1.5rem;
`;

export const BackgroundContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0.8;
`;

export const BackgroundRectangle = styled.div<{ opacity: number }>`
    width: 100%;
    height: 3rem;
    opacity: ${({ opacity }) => opacity};
    background: #fff;
    border-bottom: 0.5px solid #bfbfbf;
`;
